export enum CopyPasteKeys {
  KeyA = 65,
  KeyC = 67,
  KeyV = 86,
  KeyX = 88,
}
